import { Controller } from "@hotwired/stimulus"

// Automatically scrolls element into view when it connects
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}
